import './index.css';

/**
 * Full-bleed dark loading state with a single neutral spinner — no text.
 *
 * Used everywhere the app is mid-bootstrap with no decision to show the user
 * yet: the silent-login decide/redirect window on Home, the post-auth
 * verification-form preflight (as an overlay over Layout), and the OAuth
 * callback's token exchange. Keeping one identical visual across all of those
 * makes the silent-login round-trip read as a single continuous load instead
 * of a sequence of distinct flashing pages.
 *
 * @param {{ label?: string, overlay?: boolean }} props
 *   label — accessible status label (visually hidden).
 *   overlay — when true, covers the viewport as a fixed layer so Layout /
 *     the verification mount point can stay in the DOM underneath without
 *     flashing chrome or an empty form.
 */
export function LoadingScreen({ label = 'Loading…', overlay = false }) {
  return (
    <div
      className={
        overlay ? 'loading-screen loading-screen--overlay' : 'loading-screen'
      }
      role="status"
      aria-busy="true"
    >
      <span className="loading-screen__spinner" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </div>
  );
}
